/**保留两位小数*/
let numberFilter = data => {
        if (typeof(data) !== 'number') return '';
        return data.toFixed(2);
    }
    /**保留两位小数*/
let dosageFilter = data => {
        if (typeof(data) !== 'number') return '';
        return Math.round(data * 100) / 100;
    }
    // 向右移位
function shiftRight(number, digit) {
    digit = parseInt(digit, 10);
    var value = number.toString().split('e');
    return +(value[0] + 'e' + (value[1] ? (+value[1] + digit) : digit))
}
// 向左移位
function shiftLeft(number, digit) {
    digit = parseInt(digit, 10);
    var value = number.toString().split('e');
    return +(value[0] + 'e' + (value[1] ? (+value[1] - digit) : -digit))
}
/**金额转大写*/
let digitUppercase = function(n) {
    var fraction = ['角', '分'];
    var digit = [
        '零', '壹', '贰', '叁', '肆',
        '伍', '陆', '柒', '捌', '玖'
    ];
    var unit = [
        ['元', '万', '亿'],
        ['', '拾', '佰', '仟']
    ];
    var head = n < 0 ? '欠' : '';
    n = Math.abs(n);
    var s = '';
    for (var i = 0; i < fraction.length; i++) {
        s += (digit[Math.floor(shiftRight(n, 1 + i)) % 10] + fraction[i]).replace(/零./, '');
    }
    s = s || '整';
    n = Math.floor(n);
    for (var i = 0; i < unit[0].length && n > 0; i++) {
        var p = '';
        for (var j = 0; j < unit[1].length && n > 0; j++) {
            p = digit[n % 10] + unit[1][j] + p;
            n = Math.floor(shiftLeft(n, 1));
        }
        s = p.replace(/(零.)*零$/, '').replace(/^$/, '零') + unit[0][i] + s;
    }
    return head + s.replace(/(零.)*零元/, '元')
        .replace(/(零.)+/g, '零')
        .replace(/^整$/, '零元整');
};

//给时间加前缀'0'
function addZeroIfNeed(num) {
    if (num < 10) {
        return '0' + num
    }
    return num
}
/**将毫秒数转为标准时间*/
let toLocale = function(time) {
    let _time = new Date(time)
    let year = _time.getFullYear()
    let month = addZeroIfNeed(_time.getMonth() + 1)
    let day = addZeroIfNeed(_time.getDate())
    let hour = addZeroIfNeed(_time.getHours())
    let minute = addZeroIfNeed(_time.getMinutes())
    let second = addZeroIfNeed(_time.getSeconds())
    let date = year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second
    return date
};

let yesOrNo = function(value, format) {
    if (format == "是否") {
        if (value == 1) {
            return "是"
        } else return "否"
    }
}

function dateFilter(value, format) {
    if (!value || value == "9999-12-31") return "";
	if (!format) format = "yyyy-MM-dd"
	if (typeof value === "string" && value.indexOf('T') == -1) {
		var reg = new RegExp('-', "g")
		value = value.replace(reg, '/')
	}
	let date = new Date(value);
	let yyyy = date.getFullYear();
	let yy = String(yyyy).slice(-2);

	let M = date.getMonth() + 1;
	let MM = M < 10 ? "0" + M : M;

	let d = date.getDate();
	let dd = d < 10 ? "0" + d : d;

	let H = date.getHours();
	let HH = H < 10 ? "0" + H : H;

	let m = date.getMinutes();
	let mm = m < 10 ? "0" + m : m;

	let s = date.getSeconds();
	let ss = s < 10 ? "0" + s : s;

	let w = date.getDay();
	let arr = ['日', '一', '二', '三', '四', '五', '六'];
	w = arr[w];

	//排序不能变
	const opt = {
		"yyyy": yyyy, // 年
		"yy": yy,
		"MM": MM, // 月
		"M": M, // 月
		"dddd": '星期' + w, // 星期
		"ddd": '周' + w, // 星期
		"dd": dd, // 日
		"d": d, // 日
		"HH": HH, // 时
		"H": H, // 时
		"mm": mm, // 分
		"m": m, // 分
		"ss": ss, // 秒
		"s": s, // 秒
		'w': w, // 星期
	};
	let fmt = format;
	let ret;
	for (let k in opt) {
		ret = new RegExp("(" + k + ")").exec(fmt);
		if (ret) {
			fmt = fmt.replace(ret[1], opt[k])
		};
	};
	return fmt;
}

/**全局渲染方法*/
function renderFilter(id, renderData, valueFiled = 'value', displayField = 'display') {
    if (renderData) {
        var displayName = renderData.filter(item => item[valueFiled] == id);
        if (displayName.length) {
            return displayName[0][displayField];
        }
    }
    if (id == null || id == undefined) {
        return id;
    }
    return id.toString();
}

//工作中心渲染
function renderWCIDFilter(id, renderData, valueFiled = 'value', displayField = 'display') {
    if (renderData) {
        var displayName = renderData.filter(item => item[valueFiled] == id);
        if (displayName.length) {
            return displayName[0].record.wc_code + '-' + displayName[0][displayField];
        }
    }
    if (id == null || id == undefined) {
        return id;
    }
    return id.toString();
}

function bgColorFilter(id, renderData, valueField, colorField) {
    var name = id;
    if (!valueField)
        valueField = 'value';
    if (!colorField)
        colorField = 'bgcolor';
    if (renderData) {
        var displayName = renderData.filter(item => item[valueField] == id);
        if (displayName.length) {
            name = displayName[0][colorField];
        }
    }
    return name;
}

function originFilter(value) {
    switch (value) {
        case "temp":
            return "临时";
            break;
        case "plan":
            return "计划";
            break;
    }
}

export {
    numberFilter,
    dosageFilter,
    digitUppercase,
    toLocale,
    dateFilter,
    yesOrNo,
    renderFilter,
    bgColorFilter,
    originFilter, //任务来源
    renderWCIDFilter
}